import PropTypes from 'prop-types'
import styled, { css } from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row nowrap;
  align-items: stretch;
  justify-items: flex-start;
  width: 100%;
`

const Timeline = styled.div`
  display: ${props => (props.visible ? 'flex' : 'none')};
  flex-direction: row;
  align-items: ${props => (props.first ? 'flex-end' : 'stretch')};
  margin-left: ${props => `${props.margin.left}px`};
  margin-right: ${props => `${props.margin.right}px`};
`

const Content = styled.div`
  width: 100%;
`

const VerticalLine = styled.div`
  width: 13px;
  padding-top: ${props => (props.center ? 0 : `${props.top + 3}px`)};
  background-color: ${props => props.bgColor};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: ${props => (props.center ? 'center' : 'flex-start')};

  ${props =>
    props.first &&
    css`
      height: calc(100% - ${props => `${props.top}px`});
      padding-top: 2px;
      margin-top: ${props => `${props.top}px`};
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    `};

  ${props =>
    props.first &&
    props.center &&
    css`
      height: calc(50% + 7px);
      align-items: flex-start;
    `};

  ${props =>
    props.last &&
    css`
      align-items: flex-end;
      padding-bottom: 2px;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
    `};

  ${props =>
    props.last &&
    props.center &&
    css`
      height: calc(50% + 7px);
    `};

  ${props =>
    props.last &&
    !props.center &&
    css`
      height: ${props => `${props.top + 14}px`};
    `};
`

const Badge = styled.div`
  height: 9px;
  width: 9px;
  background-color: ${props => (props.$color ? props.$color : getToken('color-primary'))};
  border-radius: 50%;
  display: ${props => (props.noBadge ? 'none' : 'block')};
`

function TimelineItem(props) {
  return (
    <Wrapper>
      <Timeline first={props.first} visible={props.visible} margin={props.margin}>
        <VerticalLine
          top={props.top}
          center={props.center}
          first={props.first}
          last={props.last}
          bgColor={props.bgColor}
          data-testid="timelineLine"
        >
          <Badge $color={props.color} data-testid="timelineBadge" noBadge={props.noBadge} />
        </VerticalLine>
      </Timeline>
      <Content>{props.children}</Content>
    </Wrapper>
  )
}

const colorType = PropTypes.oneOfType([PropTypes.string, PropTypes.func])

TimelineItem.propTypes = {
  first: PropTypes.bool,
  last: PropTypes.bool,
  center: PropTypes.bool,
  color: colorType,
  top: PropTypes.number,
  margin: PropTypes.shape({ left: PropTypes.number, right: PropTypes.number }),
  visible: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  noBadge: PropTypes.bool,
  bgColor: colorType,
}

TimelineItem.defaultProps = {
  first: false,
  last: false,
  center: false,
  color: undefined,
  top: 0,
  margin: { left: 10, right: 10 },
  visible: true,
  children: [],
  noBadge: false,
  bgColor: '#e7eaed',
}

export { TimelineItem }
